import { groupBy } from "lodash";
import type { ActiveConfig, FailedConfig, GetTimingServiceStatusQuery } from "../../testing/utils/generated/graphql";

export type GroupedTimingStatus = {
  [timingServiceConfigID: string]: (ActiveConfig & { failed: boolean }) | (FailedConfig & { failed: boolean });
};

// Here we combine the active and failed services into a single object
export const groupTimingServiceStatusUpdates = (
  data: GetTimingServiceStatusQuery | undefined,
): GroupedTimingStatus | undefined => {
  if (!data) return undefined;

  // When assigning the object values the "failed" flag is added so that we can differentiate between the failed and active services
  const activeConfigs = groupBy(
    data.timingServiceStatus?.activeConfigs?.map(config => ({
      ...config,
      failed: false,
    })),
    "timingServiceConfigID",
  );
  const failedConfigs = groupBy(
    data.timingServiceStatus?.failedConfigs?.map(config => ({
      ...config,
      failed: true,
    })),
    "timingServiceConfigID",
  );

  const allTimingStatus = {
    ...activeConfigs,
    ...failedConfigs,
  };

  if (Object.keys(allTimingStatus).length < 1) return undefined;

  // KEY = timingServiceConfigID : VALUE = timingServiceStatus object (active or failed)
  let groupedTimingStatus = {};

  Object.keys(allTimingStatus).forEach(key => {
    groupedTimingStatus = {
      ...groupedTimingStatus,
      [key]: allTimingStatus[key][0],
    };
  });

  return groupedTimingStatus;
};
